//import $ from 'jquery';
//import 'jquery-validation';

export const noMessages = {
    alphanumeric: "bokstaver, tall og understreker bare takk",
    required: "angi en verdi.",
    remote: "ugyldig verdi.",
    email: "angi en gyldig epostadresse.",
    url: "angi en gyldig URL.",
    date: "angi en gyldig dato.",
    dateISO: "angi en gyldig dato (����-MM-DD).",
    number: "angi et gyldig tall.",
    digits: "skriv kun tall.",
    equalTo: "skriv samme verdi igjen.",
    //maxlength: $.validator.format("maksimalt {0} tegn."),
    //minlength: $.validator.format("minimum {0} tegn."),
    //rangelength: $.validator.format("angi minimum {0} og maksimum {1} tegn."),
    //range: $.validator.format("angi en verdi mellom {0} og {1}."),
    //max: $.validator.format("angi en verdi som er mindre eller lik {0}."),
    //min: $.validator.format("angi en verdi som er st�rre eller lik {0}."),
    //step: $.validator.format("angi en verdi ganger {0}."),
    creditcard: "angi et gyldig kredittkortnummer.",
    alphanumericRestricted: "bokstaver, tall og understreker bare takk",
    reviewrange: "gi oss et poeng",
    phoneNumber: "vennligst oppgi et gyldig telefonnummer",
    noSpace: "Please remove any whitespace",
    passwordCheck: "Password does not meet requirements. Please use at least one upper-case character, one lower-case character, and one number."
} as const;